module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/facility-48c1d559f1b8379d199e892236218667.webp";